// Modules
import cn from 'classnames';

// Types
import type { TStepProps } from './Stepper.type';

// Styles
import styles from './styles/Step.module.scss';

// Constants
import { STEP_DEFAULT_PROPS, STEPPER_STATUS } from './Stepper.constant';
import Icon from '../Icon/index';

const Step = (props: TStepProps) => {
	const {
		className,
		description,
		indicator,
		orientation = STEP_DEFAULT_PROPS.orientation,
		position = STEP_DEFAULT_PROPS.position,
		status,
		textPosition = STEP_DEFAULT_PROPS.textPosition,
		title,
		...restProps
	} = props
	const isCompleted = status === STEPPER_STATUS.complete

	const stepCN = cn(styles.legion_step, className, styles[position!], styles[orientation!], styles[textPosition!], styles[status!])

	return (
		<div className={stepCN} {...restProps}>
			<div className={styles.indicator}>
				{isCompleted ? (
					<Icon
						icon={'check'}
						style={{
							backgroundColor: 'var(--stepper-color-success-indicator-label)',
						}}
					/>
				) : (
					indicator
				)}
			</div>
			<div className={styles.label_section}>
				<p className={styles.title}>
					{title}
				</p>
				<p className={styles.description}>
					{description}
				</p>
			</div>
		</div>
	)
}

export default Step
